import { render } from "./Legislation.vue?vue&type=template&id=99bdf66c"
import script from "./Legislation.vue?vue&type=script&lang=js"
export * from "./Legislation.vue?vue&type=script&lang=js"

import "./Legislation.vue?vue&type=style&index=0&id=99bdf66c&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__